// extracted by mini-css-extract-plugin
module.exports = {"avatar":"AccountAvatar_avatar__2yiKj"};